import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutDefaultComponent } from './components/layouts/default/layout-default.component';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutDefaultComponent,
    loadChildren: () => import('./pages/alerts/visualization/alerts-visualization-page.module').then(m => m.AlertsVisualizationPageModule)
  },
  {
    path: 'home',
    redirectTo: '/alertas/consulta',
    pathMatch: 'full'
  },

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
